// extracted by mini-css-extract-plugin
export default {"sortIconActive":"GeneratedByData_sortIconActive__3uX0u","sortIconInactive":"GeneratedByData_sortIconInactive__psFb6"};